export enum ButtonType {
    Primary,
    Secondary,
    Tertiary,
}

export type ButtonSize = "small" | "medium" | "large" | "tiny"
